import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${colors.black1};
  height: calc(100vh - 100px);
  min-height: 610px;
  margin-top: 100px;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  background-color: ${colors.black1};
  letter-spacing: 1px;
  height: 100%;
`;

export const NavContainer = styled.div`
  width: 250px;
  min-width: 250px;
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  background-color: ${colors.black1};
  letter-spacing: 1px;
  height: 100%;
`;